export default __webpack_public_path__ + "static/media/warning--shared-lane-motorcycles-bicycles--g1.969c6687.png";